export default __webpack_public_path__ + "static/media/Gemma 9781846168949.40ee44a2.jpg";